import { Dispatch } from 'redux'

import {
	actionTypes,
	fetchQACheckFiles,
	fetchQAChecksListError,
	fetchQACheckFilesFailed,
	QAChecksFetchListAction,
	QAChecksSetCurrentAction,
	QAChecksFetchFilesAction,
	fetchQAChecksListSuccess,
	fetchQACheckFilesSuccess,
} from './actions'

import { applyFilterParams } from '../../utils/scans'

import { RootState } from '../rootReducer'
import { File } from '../../lib/interfaces/File.interface'
import { QACheck } from '../../lib/interfaces/QACheck.interface'

import * as qaChecksApi from '../../lib/api/qaChecks'

const { createLogic } = require('redux-logic')

type OnDoneType = () => void

const onFetchQAChecksListLogic = createLogic({
	type: actionTypes.QA_CHECKS_FETCH_LIST,
	process(
		{
			action,
			getState,
		}: { action: QAChecksFetchListAction; getState: () => RootState },
		dispatch: Dispatch,
		done: OnDoneType,
	) {
		const { next } = action.payload

		const filterParams = applyFilterParams(getState().qaChecks.filterParams)
		qaChecksApi
			.getQAChecksList(filterParams)
			.then((qaChecks: QACheck[]) => {
				dispatch(fetchQAChecksListSuccess(qaChecks))
				if (next) {
					next(null, qaChecks)
				}
			})
			.catch((err) => {
				dispatch(fetchQAChecksListError(err))
				if (next) {
					next(err)
				}
			})
			.then(done)
	},
})

const onSetCurrentQACheckLogic = createLogic({
  type: actionTypes.QA_CHECKS_SET_CURRENT,
  process({ action }: { action: QAChecksSetCurrentAction }, dispatch: Dispatch, done: OnDoneType) {
    const { qaCheck } = action.payload

    if (!qaCheck) {
      return done()
    }

		dispatch(fetchQACheckFiles(qaCheck.id))
		done()
  }
})

const onFetchEmployeFilesLogic = createLogic({
  type: actionTypes.QA_CHECKS_FETCH_FILES,
  process({ action }: { action: QAChecksFetchFilesAction }, dispatch: Dispatch, done: OnDoneType) {
    const { qaCheckId } = action.payload
    
    qaChecksApi.getQACheckFiles(qaCheckId)
      .then((files: File[]) => dispatch(fetchQACheckFilesSuccess(files, qaCheckId)))
      .catch(err => dispatch(fetchQACheckFilesFailed(err)))
      .then(done)
  }
})

export const qaChecksLogic = [onFetchQAChecksListLogic, onSetCurrentQACheckLogic, onFetchEmployeFilesLogic]



// WEBPACK FOOTER //
// ./src/store/qaChecks/logic.ts